export const leaderBoardDynamic='leaderboard/special_ios'
export const freeGiftRedeem='redeem/use'
export const freeRefCode='freePage/refCode'
export const shopGet='shop/get'
export const userData='users/data'
export const walletGet='wallet/get'
export const offCode='shop/offCode2'
export const buy='shop/buy/pwa'
export const walletReqPayHistory='wallet/reqPayHistory'
export const walletHistory='wallet/history'
export const walletReqPay='wallet/reqPay'
export const walletConvert='wallet/convert'
export const lcLuckSpinner='/home/luck-spinner'
export const avatarList='/avatar/list'
export const avatarBuy='avatar/buy'
export const usersUpdateProfile='users/updateProfile'
export const usersLogin='users/login'
export const usersValidate='users/validate'
export const giftHallCheck='giftHall/check2'
export const giftHallList='giftHall/list'
export const giftHallHelp='giftHall/help'
export const sessionList='session/list'
export const sessionNew='session/new'
export const sessionGetQuestion='session/getQuestion'
export const sessionAnswerQuestion='session/answerQuestion'
export const rollList='roll/list_V2'
export const rollDo='roll/do_V2'
export const giftLogoCheck='gift/logo/check'
export const giftLogoGet='gift/logo/get'
export const sessionHelp='session/useHelp'
export const giftDaily='gift/daily'
export const actionMainGet='actionMain/get'
export const dailyGift='gift/daily'
export const report='session/report'